{
  "page": {
    "title": "Orders",
    "customerFallback": "Customer {{id}}",
    "itemCount_one": "{{count}} item",
    "itemCount_other": "{{count}} items",
    "filterCustomer": "Filtered by customer: {{id}}",
    "filterConversation": "Filtered by conversation: {{id}}",
    "clearFilter": "Clear filter",
    "retry": "Retry",
    "empty": "No orders yet",
    "number": "Number",
    "status": "Status",
    "customer": "Customer",
    "items": "Items",
    "total": "Total",
    "createdAt": "Created",
    "previous": "Previous",
    "next": "Next",
    "pageNumber": "Page {{page}}"
  },
  "status": {
    "pendingPayment": "Awaiting payment",
    "paid": "Paid",
    "shipped": "Shipped",
    "cancelled": "Cancelled",
    "all": "All"
  },
  "detail": {
    "notFound": "Order not found",
    "backToOrders": "Back to orders",
    "resent": "Sent to the customer again.",
    "noChat": "This customer does not have a chat where the order card can be sent.",
    "resendFailed": "Could not resend the order.",
    "back": "Back",
    "openChat": "Open in inbox",
    "resend": "Send to customer again",
    "productItems": "Products",
    "customer": "Customer",
    "timeline": "Timeline",
    "created": "Order created",
    "paid": "Payment received",
    "shipped": "Shipped",
    "cancelled": "Cancelled"
  },
  "create": {
    "title": "Create order",
    "customer": "Customer:",
    "loadProductFailed": "Could not load the product.",
    "addProductFirst": "Add at least one product first.",
    "success": "Order created.",
    "failed": "Could not create the order.",
    "searchProducts": "Search products…",
    "productsEmpty": "No products found",
    "previous": "← Previous",
    "next": "Next →",
    "pageNumber": "Page {{page}}",
    "cart": "Cart",
    "cartEmpty": "Your cart is empty — choose a product above.",
    "perItem": "{{price}} / item",
    "remove": "Remove",
    "discountBaht": "Discount (THB)",
    "shippingBaht": "Shipping (THB)",
    "storeShipping": "store delivery rate",
    "shippingAddress": "Shipping address",
    "recipientName": "Recipient name",
    "phone": "Phone number",
    "houseNumber": "House number",
    "soi": "Soi",
    "road": "Road",
    "subDistrict": "Subdistrict",
    "district": "District",
    "province": "Province",
    "postalCode": "Postal code",
    "subtotal": "Subtotal",
    "discount": "Discount",
    "shipping": "Shipping",
    "total": "Total",
    "skuEmpty": "No SKUs yet",
    "defaultOption": "Default",
    "stockRemaining": "{{sku}} · {{count}} in stock",
    "outOfStock": "Out of stock",
    "pickCustomer": "Choose customer",
    "searchCustomer": "Search by name, phone, or #tag",
    "customerEmpty": "No customers found"
  },
  "itemsTable": {
    "product": "Product",
    "price": "Price",
    "quantity": "Quantity",
    "total": "Total"
  },
  "address": {
    "title": "Shipping address",
    "moo": "Moo {{value}}",
    "room": "Room {{value}}",
    "floor": "Floor {{value}}",
    "soi": "Soi {{value}}",
    "road": "Road {{value}}"
  },
  "actions": {
    "markPaid": "Mark as paid",
    "markShipped": "Mark as shipped",
    "cancel": "Cancel order",
    "updateFailed": "Could not update the status.",
    "cancelTitle": "Cancel this order?",
    "cancelDetail": "Stock will be restored automatically. This cannot be undone.",
    "confirmCancel": "Confirm cancellation",
    "no": "No"
  },
  "totals": {
    "subtotal": "Product subtotal",
    "discount": "Discount",
    "shipping": "Shipping",
    "net": "Total",
    "paymentMethod": "Payment method: {{method}}",
    "promptPay": "PromptPay",
    "bankTransfer": "Bank transfer",
    "cash": "Cash",
    "other": "Other"
  },
  "errors": {
    "load": "Could not load orders.",
    "create": "Could not create the order."
  }
}
